import axios from "../../axios";
import { GET_APPOINTMENT_LIST, GET_RESOURCE_LIST, GET_APPOINTMENT_DETAIL, CREATE_APPOINTMENT, UPDATE_STATUS, UPDATE_APPOINTMENT, RELOAD_CALENDAR, SELECT_RESOURCE, GET_FILTERED_LIST, CREATE_BLOCK_TIME, DELETE_BLOCK_TIME, CHECKOUT, GET_APPOINTMENT_SPECIFIC_DATE, CHECK_UPDATE, GET_LIST_SEARCH, DRAG_DROP_UPDATE, } from "./appointmentTypes";
import { LIST_ALL, LIST_RESOURCE, APPOINTMENT_DETAIL, URL_CREATE_APPOINTMENT, URL_UPDATE_STATUS, URL_UPDATE_APPOINTMENT, URL_CREATE_BLOCK_TIME, URL_DELETE_BLOCK_TIME, URL_CHECKOUT, URL_GET_APPOINTMENT_SPECIFIC_DATE, URL_CHECK_UPDATE, LIST_SEARCH, DRAG_DROP_UPDATE_URL, } from "./appointmentUrls";

import { ResponseModel } from '../../models/network/response_model'

export default {
  [GET_APPOINTMENT_LIST]({ commit }, params) {
    return new Promise((resolve) => {
      axios.get(LIST_ALL, {
        params: params
      }).then(async (response) => {
        let responseModel = new ResponseModel(response);
        await commit(GET_APPOINTMENT_LIST, responseModel.result.data);
        resolve();
      });
    })
  },

  [GET_RESOURCE_LIST]({ commit }, params) {
    axios.get(LIST_RESOURCE, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_RESOURCE_LIST, responseModel.result.data);
    });
  },

  [GET_APPOINTMENT_DETAIL]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(APPOINTMENT_DETAIL, {
        params: params
      }).then((response) => {
        let responseModel = new ResponseModel(response);
        if (responseModel.status == "FAIL") {
          commit(GET_APPOINTMENT_DETAIL, []);
          reject("This appointment is cancelled");
        } else if (responseModel.status == "OK") {
          commit(GET_APPOINTMENT_DETAIL, responseModel.result.data);
          resolve();
        } else {
          reject("Appointment fetching error");
        }
      });
    })
  },

  [CREATE_APPOINTMENT]({ dispatch }, data) {
    axios.post(`${URL_CREATE_APPOINTMENT}`, data)
      .then(() => {
        dispatch(RELOAD_CALENDAR);
      })
      .catch((error) => { console.log(error) });
  },

  [UPDATE_APPOINTMENT]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_APPOINTMENT}`, data)
        .then((response) => {
          dispatch(RELOAD_CALENDAR);
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) });
    })
  },

  [UPDATE_STATUS]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_STATUS}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  async [RELOAD_CALENDAR]({ dispatch, state, commit }, data) {
    if (data != null) {
      commit(RELOAD_CALENDAR, data);
    }
    await dispatch(GET_APPOINTMENT_LIST, state.calendarView);
    await dispatch(GET_RESOURCE_LIST, state.calendarView);

    await commit(GET_FILTERED_LIST);
  },

  [SELECT_RESOURCE]({ commit, dispatch }, data) {
    commit(SELECT_RESOURCE, data);
    dispatch(RELOAD_CALENDAR);
  },

  [GET_FILTERED_LIST]({ commit }) {
    commit(GET_FILTERED_LIST);
  },

  [CREATE_BLOCK_TIME]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_BLOCK_TIME}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_BLOCK_TIME]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DELETE_BLOCK_TIME}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECKOUT]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_CHECKOUT, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_APPOINTMENT_SPECIFIC_DATE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_APPOINTMENT_SPECIFIC_DATE, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          resolve();
          commit(GET_APPOINTMENT_SPECIFIC_DATE, responseModel.result.data);
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECK_UPDATE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_CHECK_UPDATE, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          commit(CHECK_UPDATE, responseModel.result.data);
          resolve(responseModel.result.data);
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_LIST_SEARCH]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(LIST_SEARCH, {
        params
      }).then((response) => {
        let responseModel = new ResponseModel(response);
        commit(GET_LIST_SEARCH, responseModel.result.data);
        resolve(responseModel.result.data);
      })
        .catch((error) => { reject(error) });
    })
  },

  [DRAG_DROP_UPDATE]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(DRAG_DROP_UPDATE_URL, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == "OK") {
            dispatch(RELOAD_CALENDAR);
            resolve();
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
}
